<template>
  <v-container fluid grid-list-sm>
    <v-layout justify-end row>
      <v-flex xs12 sm4 md4>
        <v-select
          dense
          :items="firmsByBrand"
          label="Select Firm"
          v-model="selectedFirm"
        ></v-select>
      </v-flex>
      <v-flex xs12 sm3 md3>
        <v-select
          dense
          v-model="selectedProduct"
          :items="productsByBrand"
          label="Select Product"
          item-text="name"
          return-object
          clearable
        >
        </v-select>
      </v-flex>
      <v-flex xs12 sm3 md3>
        <v-select
          v-bind:items="isBuyer ? buyersByBrand : sellersByBrand"
          v-model="selectedBuyer"
          :label="isBuyer ? 'Select Buyer' : 'Select Seller'"
          autocomplete
          item-text="name"
          clearable
          return-object
        >
        </v-select>
      </v-flex>

      <v-spacer></v-spacer>
      <v-flex xs12 sm2 md2>
        <v-switch
          v-model="isBuyer"
          class="js-customer-switcher"
          :label="`${isBuyer ? 'Sale' : 'Purchase'}`"
          @change="selectedBuyer = null"
        ></v-switch>
      </v-flex>
      <v-flex xs12 sm2 md2>
        <v-menu
          :close-on-content-click="false"
          v-model="datepickerMenu1"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="startDate"
            label="Start Date"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker
            v-model="startDate"
            @input="datepickerMenu1 = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm2 md2>
        <v-menu
          :close-on-content-click="false"
          v-model="datepickerMenu2"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="endDate"
            label="End Date"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker
            v-model="endDate"
            @input="datepickerMenu2 = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>

      <v-spacer></v-spacer>

      <!-- <v-flex xs12 sm1 md1 style="margin-top: 10px;">
          <v-btn @click="printInv()" class="primary white--text">
            Print
          </v-btn>
        </v-flex> -->
    </v-layout>

    <template>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-data-table
            :items="productList"
            class="elevation transaction-table"
            hide-actions
            :headers="headers"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>
                  <b class="font-weight-bold">
                    {{ new Date(props.item.date).toLocaleDateString('en-GB') }}
                  </b>
                </td>
                <td>
                  <b class="font-weight-bold">{{ props.item.rate }}</b>
                </td>
                <td>
                  <b class="font-weight-bold">{{ props.item.quantity }}</b>
                </td>
                <td v-if="isDairyBusiness">
                  <b class="font-weight-bold">{{ props.item.fat || '' }}</b>
                </td>
                <td>
                  <b class="font-weight-bold">{{ props.item.price }}</b>
                </td>
                <td>
                  <b class="font-weight-bold">{{ props.item.gst }}</b>
                </td>
                <td>
                  <b class="font-weight-bold">{{ props.item.totlePrice }}</b>
                </td>
              </tr>
            </template>
            <template slot="no-data">No rows to Show</template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </template>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  props: {
    product : Object,
    isBuyer : Boolean,
    buyerId : String,
  },
  data: () => ({
    headers: [
      { text: "Date", value: "date", sortable: true },
      { text: "Rate", value: "rate", sortable: false },
      { text: "Quantity", value: "quantity", sortable: false },
      { text: "Fat", value: "fat", sortable: false},
      { text: "Basic Price", value: "basicPrice", sortable: false },
      { text: "GST", value: "gst", sortable: false },
      { text: "Total", value: "closingQuantity", sortable: false },
    ],
    datepickerMenu1: false,
    datepickerMenu2: false,
    startDate: null,
    endDate: null,
    // isBuyer: false,
    selectedProduct: null,
    selectedBuyer: null,
  }),
  created() {
    this.$bindAsArray(
      "invoiceHistory",
      this.$root.$firebaseRefs.invoiceHistory
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "products",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "buyers",
      this.$root.$firebaseRefs.buyer
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "sellers",
      this.$root.$firebaseRefs.seller
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
        "firms",
        this.$root.$firebaseRefs.firm
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
    this.startDate = new Date(this.finYear.start).toISOString().substr(0, 10);
    this.endDate = new Date(this.finYear.end).toISOString().substr(0, 10);
     if(this.product && this.product['.key']) {
      this.selectedProduct = this.product;
    }
    if(this.buyerId) {
      if(this.isBuyer) {
        this.selectedBuyer = this.buyersByBrand.find(i => i['.key'] == this.buyerId)
      } else {
        this.selectedBuyer = this.sellersByBrand.find(i => i['.key'] == this.buyerId)
      }
    }
  },
  watch:{
    "product" : {
      handler(newVal){
        if(this.product && this.product['.key']) {
          this.selectedProduct = this.product;
        }
      },
      deep :true
    }
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear"]),
    // headers () {
    //   return this.headers.filter(x=>x.show)
    // },
    buyersByBrand() {
      return this.buyers.filter((item) => {
        return item["brand"] === this.selectedBrand;
      });
    },
    sellersByBrand() {
      return this.sellers.filter((item) => {
        return item["brand"] === this.selectedBrand;
      });
    },
    firmsByBrand() {
      return this.firms
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          if (item.defaultFirm) {
            this.selectedFirm = item[".key"];
          }
          return {
            text: item["name"],
            value: item[".key"],
          };
        });
    },
    isDairyBusiness() {
      if (this.selectedFirm) {
        let firm = this.firms.find((item) => item[".key"] == this.selectedFirm);
        if (firm.businessType == "Dairy") {
          return true;
        }
      }
      return false;
    },
    productsByBrand() {
      return this.products.filter(
        (item) => item["brand"] === this.selectedBrand &&
        item["firm"] === this.selectedFirm
      );
    },
    productList() {
      let products = [];
      if (this.selectedProduct) {
        let fromDate = this.startDate
          ? new Date(this.startDate).getTime()
          : null;
        let toDate = this.endDate ? new Date(this.endDate).getTime() : null;
        let invoiceHistory = this.invoiceHistory.filter(
          (item) =>
            item["brand"] === this.selectedBrand &&
            item.deleted != true &&
            (this.selectedBuyer
              ? item.buyerId == this.selectedBuyer[".key"]
              : true) &&
            (fromDate ? item.date >= fromDate : true) &&
            (toDate ? item.date <= toDate : true) &&
            (item["isLatest"] != undefined ? item["isLatest"] == true : true)
        );
        invoiceHistory.map((item, index) => {
          if (
            item.newlyCreated &&
            (item.status === "paid" || item.status === "partial")
          ) {
            let newItem = JSON.parse(JSON.stringify(item));
            newItem.date = newItem.date - 1;
            newItem.transactionType = "Debit";
            newItem.paidAmount = 0;
            newItem.status = "due";
            newItem.remainingAmount = newItem.totalAmount;
            delete newItem["newlyCreated"];
            invoiceHistory.push(newItem);
          }
          if (this.isBuyer == item.isBuyer) {
            item.items &&
              item.items.length &&
              item.items.map((prod) => {
                if (prod["productId"] == this.selectedProduct[".key"]) {
                  products.push({
                    price: prod.basicPrice,
                    quantity: prod.quantity,
                    fat: prod.fat,
                    rate: prod.rate,
                    date: item.date,
                    totlePrice: prod.totlePrice,
                    gst: prod.GSTValue || 0,
                    isBuyer: item.isBuyer,
                  });
                }
              });
          }
        });
      }
      return products;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ProductReports/ProductReports.vue